import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

@Injectable()
export class ActivityStoreInstructionActionFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient,
         @Inject('BASE_URL') baseUrl: string,
         private _datePipe: DatePipe) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetSummary(catDetTaskTypeId: number, startDate: Date, endDate: Date): Observable<any> {
        const startDateString =  this._datePipe.transform(startDate, 'yyyyMMdd');
        const endDateString =  this._datePipe.transform(endDate, 'yyyyMMdd');
        return this._httpClient.get<any>(this._urlBase +
                                         'api/ActivityStoreInstructionAction/Summary?catDetTaskTypeId=' +
                                         catDetTaskTypeId +
                                         '&startDate=' + startDateString + '&endDate=' + endDateString);
    }

    GetReport(storeId: number, catDetTaskTypeId: number, startDate: any, endDate: any, language: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase +
            'api/ActivityStoreInstructionAction/Report?storeId=' + storeId +
            '&catDetTaskTypeId=' + catDetTaskTypeId +
            '&startDate=' + startDate + '&endDate=' + endDate + '&language=' + language);
    }

    GetReportDetail(storeId: number, startDate: any, endDate: any, language: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase +
            'api/ActivityStoreInstructionAction/ReportDetail?storeId=' + storeId +
            '&startDate=' + startDate +
            '&endDate=' + endDate +
            '&language=' + language
            );
    }
    /*
    GetAction(activStoreInstActId:number): Observable<any>
    {
        return this._httpClient.get<any>(this._urlBase +
            'api/ActivityStoreInstructionAction?ActivStoreInstActId=' + activStoreInstActId);
    }
    */
}
